export default {
  formular: 'Formular, Helvetica, Arial, sans-serif',
  spoof: 'Spoof, sans-serif',
  mPlus1: "'M PLUS 1', Formular, sans-serif",
}
